import React, { useState, useEffect } from 'react';
import botAPI from '../botAPI.js';

const STORAGE_KEY = 'cookie_consent';

const CookieBanner = React.memo(function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem(STORAGE_KEY);
      if (consent) {
        const parsed = JSON.parse(consent);
        if (parsed.status === 'accepted') return;
      }
    } catch {
      // corrupted value — show banner
    }
    setMounted(true);
    // Delay to trigger CSS transition
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setVisible(true));
    });
  }, []);

  const handleAccept = () => {
    const value = JSON.stringify({
      status: 'accepted',
      timestamp: new Date().toISOString(),
    });
    localStorage.setItem(STORAGE_KEY, value);

    // Fire-and-forget: отправляем согласие на сервер для аудит-лога
    botAPI.sendCookieConsent('granted').catch(() => {});

    setVisible(false);
    // Remove from DOM after transition
    setTimeout(() => setMounted(false), 350);
  };

  const handleDetails = () => {
    window.open('/privacy', '_self');
  };

  if (!mounted) return null;

  return (
    <>
      {/* Mobile: above BottomNavigation */}
      <div
        className="block xl:hidden"
        style={{
          position: 'fixed',
          bottom: 'calc(56px + env(safe-area-inset-bottom, 0px))',
          left: 0,
          right: 0,
          zIndex: 90,
          transform: visible ? 'translateY(0)' : 'translateY(100%)',
          opacity: visible ? 1 : 0,
          transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
        }}
      >
        <BannerContent onAccept={handleAccept} onDetails={handleDetails} />
      </div>

      {/* Desktop (>=1280px): at the very bottom */}
      <div
        className="hidden xl:block"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 90,
          transform: visible ? 'translateY(0)' : 'translateY(100%)',
          opacity: visible ? 1 : 0,
          transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
        }}
      >
        <BannerContent onAccept={handleAccept} onDetails={handleDetails} />
      </div>
    </>
  );
});

function BannerContent({ onAccept, onDetails }) {
  return (
    <div
      className="bg-white/95 dark:bg-gray-800/95 backdrop-blur-lg border-t border-gray-200/60 dark:border-gray-700/40 shadow-lg"
      style={{ width: '100%' }}
    >
      <div
        className="flex items-center justify-between gap-3 px-4 py-3"
        style={{ maxWidth: '1280px', margin: '0 auto' }}
      >
        <p className="text-sm text-gray-600 dark:text-gray-300 leading-snug">
          Мы используем файлы cookie для улучшения работы сайта.{' '}
          <button
            onClick={onDetails}
            className="text-sky-500 hover:underline text-sm bg-transparent border-none cursor-pointer p-0 inline"
          >
            Подробнее
          </button>
        </p>
        <button
          onClick={onAccept}
          className="bg-sky-500 hover:bg-sky-600 text-white px-4 py-2 rounded-lg font-medium text-sm whitespace-nowrap transition-colors duration-150 border-none cursor-pointer flex-shrink-0"
        >
          Принять
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
